// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2UZWx","row":"Node_row__2e0hD","label":"Node_label__3fpQv","footer":"Node_footer__2G-pp"};